export default "__VITE_ASSET__3f077141__"